import type { PayrollConceptSelectFieldFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { AdditionalCompensationWizardModal } from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/_AdditionalCompensations/AdditionalCompensationWizard/AdditionalCompensationWizardModal'
import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'

type CreateAdditionalCompensationWizardModalProps = {
  payrollConcepts: PayrollConceptSelectFieldFragment[]
  leaveTypeOptions: Array<{ id: string; label: string }>
  onClose?: () => void
  effectiveOn?: string
  contractVersionId: string
}

function CreateAdditionalCompensationWizardModal({
  onClose,
  payrollConcepts,
  leaveTypeOptions,
  effectiveOn,
  contractVersionId,
}: CreateAdditionalCompensationWizardModalProps) {
  const { additionalCompensations, setAdditionalCompensations } = useContractFlow()

  return (
    <AdditionalCompensationWizardModal
      onClose={onClose}
      formName="create-additional-compensation-wizard"
      submitLabel={i18n.t('common.add')}
      title={i18n.t(
        'contract_versions.additional_compensation.create_additional_compensation_form_modal.title'
      )}
      payrollConcepts={payrollConcepts}
      leaveTypeOptions={leaveTypeOptions}
      effectiveOn={effectiveOn}
      contractVersionId={contractVersionId}
      onSave={(additionalCompensation) => {
        setAdditionalCompensations([...(additionalCompensations ?? []), additionalCompensation])

        track(trackingEvents.compensations.createCompensation, {
          type: 'contract',
        })
      }}
    />
  )
}

export { CreateAdditionalCompensationWizardModal }
